import { VertBox } from 'component/basics';
import { NotificationToast } from 'component/notification-toast';
import { component, demoFile } from 'system/demo';
import { t } from 'util/stdtypes';

demoFile('component/notification-toast', {
    designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=9187-10706&m=dev',
});

function NotificationToastDemo() {
    return (
        <VertBox gap={12}>
            <NotificationToast id='first' label={t('!This is a success message!')} type='success' />
            <NotificationToast id='second' label={t('!This is an error message!')} type='error' />
            <NotificationToast id='third' label={t('!This is an info message!')} type='info' />
            <NotificationToast dismissable={true} id='fourth' label={t('!This is a dismissable success message!')} type='success' />
            <NotificationToast dismissable={true} id='fifth' label={t('!This is a dismissable error message!')} type='error' />
            <NotificationToast
                dismissable={true}
                id='sixth'
                label={t('!This is a notification toast with a really long message that should wrap into multiple lines.')}
                type='info'
            />
        </VertBox>
    );
}

component('NotificationToast', NotificationToastDemo);
